<template>
	<el-drawer title="生成结款单" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
		@close="close">
		<div class="drawer-content">
			<!-- 第一步：选择合同 -->
			<el-form v-if="formData.step === 1" :model="formData" ref="formRef" label-position="top" size="medium">
				<div class="page-group-title">确认合同</div>
				<el-radio-group v-model="formData.contractId" size="medium" class="MT20">
					<el-radio v-for="item in contractList" :key="item.id" :label="item.id">
						{{ item.contractSn }} {{ item.bankAccount }} {{ item.bankAddress }}
					</el-radio>
				</el-radio-group>
			</el-form>

			<!-- 第二步：选择场次 -->
			<el-form v-if="formData.step === 2" :model="formData" ref="formRef" label-position="top" size="medium">
				<div class="page-group-title">确认场次</div>
				<div class="MT10">
					1. 秀动支持按场次申请结款，只有已结束且未申请过的场次，可以申请结款。<br>
					2. 通票只有在演出已结束的情况下，跟随演出最后一个场次一起结款。
				</div>
				<div class="page-list-box">
					<el-table :data="sessionList" border v-loading="listLoading" size="small" stripe
						@selection-change="handleSelectionChange" ref="sessionTableRef">
						<el-table-column type="selection" :selectable="isSessionSelectable" width="55" />
						<el-table-column prop="sessionName" label="场次名称" min-width="150" show-overflow-tooltip />
						<el-table-column prop="endTimeView" label="场次结束时间" min-width="150" show-overflow-tooltip />
						<el-table-column prop="settlementStatus" label="结算状态" width="130">
							<template slot-scope="{ row }">
								<el-tag :type="getSettlementStatusType(row.settlementStatus)">
									{{ getSettlementStatusText(row.settlementStatus) }}
								</el-tag>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-form>
		</div>

		<div class="drawer-footer">
			<template v-if="formData.step === 1">
				<el-button type="primary" @click="handleNextStep" icon="el-icon-right" :disabled="!formData.contractId">
					下一步
				</el-button>
			</template>

			<template v-if="formData.step === 2">
				<el-button type="primary" @click="handlePrevStep" icon="el-icon-back" v-if="hasContract">
					上一步
				</el-button>
				<el-button type="primary" @click="handleSubmit" :loading="btnLoading" :disabled="!hasSelectedSessions">
					申请结款
				</el-button>
			</template>

			<el-button @click="close">关闭</el-button>
		</div>
	</el-drawer>
</template>

<script>
	export default {
		data() {
			return {
				drawerShow: false,
				btnLoading: false,
				listLoading: false,

				// 活动数据
				activityData: null,

				// 是否有合同（用于控制步骤）
				hasContract: false,

				// 数据列表
				contractList: [],
				sessionList: [],
				selectedSessions: [],

				// 表单数据
				formData: {
					step: 1,
					contractId: '',
					sessionIds: []
				},

				// 结算状态映射
				settlementStatusMap: {
					1: {
						text: '可结算',
						type: 'success'
					},
					2: {
						text: '场次未结束',
						type: 'warning'
					},
					3: {
						text: '已申请',
						type: 'info'
					},
					4: {
						text: '已结款',
						type: 'danger'
					}
				}
			}
		},

		computed: {
			// 是否有选中的场次
			hasSelectedSessions() {
				return this.selectedSessions && this.selectedSessions.length > 0
			}
		},

		methods: {
			show(activityData) {
				this.activityData = activityData
				this.hasContract = activityData.selectContract
				// 重置表单
				this.resetForm()
				// 根据是否有合同决定第一步
				if (this.hasContract) {
					this.formData.step = 1
					this.fetchContractList()
				} else {
					this.formData.step = 2
					this.fetchSessionList()
				}
				this.drawerShow = true
			},
			// 关闭
			close() {
				this.drawerShow = false
				this.resetForm()
				this.$emit('close')
			},
			// 重置表单
			resetForm() {
				this.formData = {
					step: 1,
					contractId: '',
					sessionIds: []
				}
				this.contractList = []
				this.sessionList = []
				this.selectedSessions = []
				this.btnLoading = false
				this.listLoading = false

				if (this.$refs.formRef) {
					this.$refs.formRef.resetFields()
				}
			},

			// 获取合同列表
			async fetchContractList() {
				try {
					const res = await this.$request({
						url: '/activityFinanceSettle/contractList',
						method: 'POST',
						params: {
							activityId: this.activityData.id
						}
					})

					const {
						state,
						msg,
						result
					} = res.data
					if (state == 1 && result) {
						this.contractList = result
					} else {
						this.$message.error(msg || '获取合同信息失败')
					}
				} catch (error) {
					
					this.$message.error('获取合同信息错误')
				}
			},

			// 获取场次列表
			async fetchSessionList() {
				this.listLoading = true

				try {
					const res = await this.$request({
						url: '/activityFinanceSettle/applySessionList',
						method: 'POST',
						params: {
							activityId: this.activityData.id
						}
					})

					const {
						state,
						msg,
						result
					} = res.data
					if (state == 1 && result) {
						this.sessionList = result

						// 自动选中可结算的场次
						this.$nextTick(() => {
							this.autoSelectSessions()
						})
					} else {
						this.$message.error(msg || '获取场次信息失败')
					}
				} catch (error) {
					
					this.$message.error('获取场次信息错误')
				} finally {
					this.listLoading = false
				}
			},

			// 自动选中可结算场次
			autoSelectSessions() {
				if (!this.$refs.sessionTableRef) return

				const selectableSessions = this.sessionList.filter(
					item => item.settlementStatus == 1
				)

				if (selectableSessions.length > 0) {
					selectableSessions.forEach(session => {
						this.$refs.sessionTableRef.toggleRowSelection(session, true)
					})
				}
			},

			// 判断场次是否可选
			isSessionSelectable(row) {
				return row.settlementStatus == 1
			},

			// 获取结算状态文本
			getSettlementStatusText(status) {
				return this.settlementStatusMap[status]?.text || '未知状态'
			},

			// 获取结算状态标签类型
			getSettlementStatusType(status) {
				return this.settlementStatusMap[status]?.type || ''
			},

			// 处理选中变化
			handleSelectionChange(val) {
				this.selectedSessions = val
				this.formData.sessionIds = val.map(item => item.sessionId)
			},

			// 下一步
			handleNextStep() {
				if (!this.formData.contractId) {
					this.$message.error('请先选择合同')
					return
				}

				this.formData.step = 2
				this.fetchSessionList()
			},

			// 上一步
			handlePrevStep() {
				this.formData.step = 1
				this.selectedSessions = []
				this.formData.sessionIds = []
			},

			// 提交表单
			async handleSubmit() {
				if (!this.hasSelectedSessions) {
					this.$message.error('请至少选择一个场次')
					return
				}

				this.btnLoading = true

				try {
					const res = await this.$request({
						url: '/activityFinanceSettle/submitAudiInfo',
						method: 'POST',
						data: {
							activityId: this.activityData.id,
							contractId: this.formData.contractId,
							sessionIds: this.formData.sessionIds
						}
					})

					const {
						state,
						msg
					} = res.data
					if (state == 1) {
						this.$message.success('提交成功')
						this.$emit('onUpdate')
						this.close()
					} else {
						this.$message.error(msg || '操作失败，请重试')
					}
				} catch (error) {
					this.$message.error('操作失败，请重试')
				} finally {
					this.btnLoading = false
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.drawer-content {
		padding: 0 20px;
	}

	.page-group-title {
		font-size: 16px;
		font-weight: 500;
		margin: 20px 0 10px;
		padding-left: 8px;
		border-left: 4px solid #409EFF;
	}

	.page-list-box {
		margin-top: 20px;
	}

	.drawer-footer {
		padding: 20px;
		text-align: right;
		border-top: 1px solid #eee;
	}

	::v-deep .el-radio {
		display: block;
		margin-bottom: 12px;
		padding: 8px 12px;
		border: 1px solid #eee;
		border-radius: 4px;
		transition: all 0.3s;

		&:hover {
			border-color: #409EFF;
			background-color: #f5f7fa;
		}

		&.is-checked {
			border-color: #409EFF;
			background-color: #ecf5ff;
		}
	}
</style>